<template>

    <h2 class="section-title">{{ currentGroup.title }}</h2>


    <fields-group
        v-for="fieldGroup in fieldsGroupedAndSorted"
        :key="fieldGroup[0].key"
        :key1="fieldGroup[0].key"
        ref="allFieldsGroup"
        :group="fieldGroup">

    </fields-group>

    <div class="align-right btn-next-page-container">
        <button @click="nextPage" v-if="totalGroupCount !== 1 && !isLastGroup" class="link-show-all">
            {{ copydeck.btn_next }}
        </button>
    </div>

    <div class="centered btn-finish-container">
        <button @click="endEdit" v-if="totalGroupCount !== 1  && isLastGroup" class="link-show-all">
            {{ copydeck.btn_complete }}
        </button>
    </div>

    <div class="centered btn-finish-container end-save-last">
        <button @click="validateAndMaybeEndEdit" v-if="totalGroupCount === 1" class="link-show-all">
            {{ copydeck.btn_complete }}
        </button>
    </div>

</template>

<script>
export default {
    name : "FormWizardGroup",
}
</script>

<script setup>

import { computed, ref }        from "vue";
import { useStore }             from "vuex";
import useCopydeck              from "../composables/UseCopydeck";
import { scrollToTopOfProfile } from "../composables/UseCopydeck";
import FieldsGroup              from "./FieldsGroup.vue";
import { groupBy }              from "lodash-es";

let store    = useStore();
let copydeck = useCopydeck();

let emits = defineEmits( [ "change-screen" ] );

let user              = computed( () => store.state.user );
let currentGroupIndex = computed( () => store.state.currentGroup + 1 );
let totalGroupCount   = computed( () => store.state.totalGroup );

let currentGroup = computed( () => store.state.form.data.groups[ store.state.currentGroup ] );

let isLastGroup = computed( () => totalGroupCount.value === 1 || currentGroupIndex.value >= totalGroupCount.value );

let allFieldsGroup = ref( [] );

function fieldsPositionned ( fields )
{
    let cloneFields = [ ...fields ];
    cloneFields.forEach( ( f, index ) => f.position = index );
    return cloneFields;
}

function groupFields ( field )
{
    if ( !field.options )
        return field.key;

    let group = field.options.find( o => o.type === 'group' );

    if ( group )
        return group.group;

    return field.key;

}

async function nextPage ()
{
    let response = await store.dispatch( "validateCurrentGroup" );

    if ( response.success )
    {

        store.commit( "incrementCurrentGroup" );
        scrollToTopOfProfile();
    }
    else
    {

        allFieldsGroup.value.forEach( fsg => fsg.addErrors( response.errors ) );

    }
}

function endEdit ()
{
    store.dispatch( "updateUserProfile", { key : "completed_profile", value : true } );
    emits( "change-screen", "profile" );

    scrollToTopOfProfile();
}

function clearError (strField)
{

}

// the logic didn't work as well with single-group forms :
async function validateAndMaybeEndEdit ()
{
    let response = await store.dispatch( "validateCurrentGroup" );

    if ( response.success )
    {
        store.dispatch( "updateUserProfile", { key : "completed_profile", value : true } );
        emits( "change-screen", "profile" );

        scrollToTopOfProfile();
    } else
    {

        allFieldsGroup.value.forEach( fsg => fsg.addErrors( response.errors ) );

    }
}

//let fieldsGrouped2 = computed( () => groupBy(currentGroup.value.fields, (field) => ((field.options ?? []).find( o => o.type === 'group') ?? {group: field.key}).group));
let fieldsPositioned       = computed( () => fieldsPositionned( currentGroup.value.fields ) );
let fieldsGrouped          = computed( () => groupBy( fieldsPositioned.value, groupFields ) );
let fieldsGroupedAndSorted = computed( () => Object.values( fieldsGrouped.value ).sort( ( a, b ) => a[ 0 ].position - b[ 0 ].position ) );

defineExpose ( { clearError });
// console.log( fieldsPositioned.value );
// console.log( Object.values( fieldsGrouped.value ) );
// console.log( fieldsGroupedAndSorted.value );


</script>
